import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class socialmedia
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.socialmedia = {};

/**
 * GET Endpoint `/socialmedia/{type}/posts`
 * @param {string} socialmedia_type  (facebook, instagram, twitter)
 * @param {number} posts
 * @param {ReachAPI.Security} security
 * @param {string} [profile_id]
 * @param {string} [reach_profile_id]
 * @param {string} [timezone=UTC]
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.socialmedia
 */
ReachAPI.socialmedia.getPosts = function (
    socialmedia_type,
    posts,
    security,
    profile_id,
    reach_profile_id,
    timezone
) {
    profile_id = profile_id || 'null';
    reach_profile_id = reach_profile_id || 'null';
    timezone = timezone || 'null';

    var socialmediaPath =
        socialmedia_type === 'instagramBusiness' ? 'instagram/business' : socialmedia_type;

    var url = ReachAPI.server + '/socialmedia/' + socialmediaPath + '/posts';
    var params = {
        profile_id: profile_id,
        reach_profile_id: reach_profile_id,
        posts: posts,
        timezone: timezone,
    };
    var jqPromise;

    // add security data
    params = security.merge(params);

    jqPromise = ReachAPI.getWithFallback(url, 'json', params);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved Social Media Posts (' +
                    socialmedia_type +
                    ') from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug(
                'Retrieved Social Media Posts (' + socialmedia_type + ') from the API',
                null,
                __fileline
            );
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Social Media Posts (' + socialmedia_type + ')',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
